import { MapToContext } from '@utils/objectWithDefault'

export class WroOriginAddress {
  constructor (data) {
    const defaultData = {
      name: { val: '', type: String },
      streetAddress1: { val: '', type: String },
      streetAddress2: { val: '', type: String },
      city: { val: '', type: String },
      state: { val: '', type: String },
      zipCode: { val: '', type: String },
      country: { val: 'US', type: String }
    }
    MapToContext(this, defaultData, data)
  }
}
